import { isValidElementType } from 'react-is';

var validateComponentProp = function validateComponentProp(props, propName, componentName) {
  if (!isValidElementType(props[propName])) {
    return new Error('Invalid prop `' + propName + '` supplied to' + ' `' + componentName + '`.');
  }

  return null;
};

export default validateComponentProp;


//////////////////
// WEBPACK FOOTER
// ../redux-form/es/util/validateComponentProp.js
// module id = 159
// module chunks = 25